export default __webpack_public_path__ + "img/df63f8143bb88d243a91a344a6fd8d3c.svg";